import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Oops! Page Not Found</h2>
        <p>The page you're looking for doesn't seem to exist.</p>
        <p>Let's get you back on track!</p>
        <button onClick={goHome} className="home-button">
          Return Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
